import React, { useContext, useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
import SignupButton from './miniComponents/SignupButton'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'

const ThirdSlide = ()=> {
    return (
        <div className = 'thirdSlide'> 
            {/* <div className = 'containerTwo'> */}
            <h1>What Role You Can Choose</h1>
            <div id = 'thirdContainer'> 
                <div className = 'role'>
                    <h2>Pitcher</h2>
                    <div className = 'roleLine'></div>
                    <div className = 'restrictionRoleText'> 
                        <p>share, discuss, evolve your idea, get feedback, find like-minded people, co-founders</p>
                    </div>
                </div>
                <div className = 'role'>
                    <h2>Listener</h2>
                    <div className = 'roleLine'></div>
                    <div className = 'restrictionRoleText'> 
                        <p>listen to ideas, give feedback, discuss, inspire, brainstorm, find like-minded people, become a co-founder</p>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </div>
    )
}

export default ThirdSlide 